import { ANIMATION_CONFIG } from '../config/constants';

/**
 * スムーズスクロール関数
 * @param {HTMLElement} element - スクロール先の要素
 * @param {number} duration - スクロール時間（ミリ秒）
 * @param {number} offset - オフセット値
 */
export const scrollToElement = (
  element,
  duration = ANIMATION_CONFIG.SCROLL_DURATION,
  offset = 0
) => {
  const startPosition = window.pageYOffset;
  const targetPosition =
    element.getBoundingClientRect().top + window.pageYOffset - offset;
  const distance = targetPosition - startPosition;
  let startTime = null;

  const animation = currentTime => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  };

  // イージング関数
  const ease = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  requestAnimationFrame(animation);
};

/**
 * セクションIDに基づいてスクロール
 * @param {string} sectionId - セクションID
 * @param {number} offset - オフセット値
 */
export const scrollToSection = (sectionId, offset = 80) => {
  const element = document.getElementById(sectionId);
  if (element) {
    scrollToElement(element, ANIMATION_CONFIG.SCROLL_DURATION, offset);
  }
};

/**
 * ヘッダーの高さを取得
 * @returns {number} ヘッダーの高さ
 */
export const getHeaderHeight = () => {
  const header = document.querySelector('header');
  return header ? header.offsetHeight : 0;
};

/**
 * 現在のスクロール位置を取得
 * @returns {number} スクロール位置
 */
export const getCurrentScrollPosition = () => {
  return window.pageYOffset || document.documentElement.scrollTop;
};

/**
 * 要素が画面内に表示されているかチェック
 * @param {HTMLElement} element - チェックする要素
 * @param {number} threshold - しきい値（0-1）
 * @returns {boolean} 表示されているかどうか
 */
export const isElementInView = (element, threshold = 0.5) => {
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const elementHeight = rect.height;
  const visibleHeight =
    Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

  return visibleHeight / elementHeight >= threshold;
};
